import { CellProps } from 'react-table'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { PlainHeader, sortableColumn, StackedCell, TableColumn } from '../../../../../../components'
import { FaturaProfissionalDtoList } from '../../core/_models'
import { FaturaProfissionalActionsCell } from './FaturaProfissionalActionsCell'
import { SituacaoFaturaBadge } from '../../../faturas-list/components/SituacaoFaturaBadge'
import { TFunction } from '_metronic/i18n/Metronici18n'

export const faturaProfissionalColumns = (
  t: TFunction
): ReadonlyArray<TableColumn<FaturaProfissionalDtoList>> => [
  sortableColumn<FaturaProfissionalDtoList>({
    id: 'empresa.nomeFantasia',
    useQueryRequest,
    fields: [{ field: 'empresa.nomeFantasia', label: t('cols.instituicao') }],
    Cell: ({ row }: CellProps<FaturaProfissionalDtoList>) => (
      <StackedCell primary={row.original.empresa?.nomeFantasia} />
    ),
  }),
  // Período de competência com a data de geração como apoio; os dois seguem ordenáveis.
  sortableColumn<FaturaProfissionalDtoList>({
    id: 'mesAno.mes',
    cellWidth: '168px',
    useQueryRequest,
    fields: [
      { field: 'mesAno.mes', label: t('cols.periodo') },
      { field: 'data', label: t('cols.data') },
    ],
    Cell: ({ row }: CellProps<FaturaProfissionalDtoList>) => {
      const { mesSigla, ano } = row.original.mesAno ?? {}
      return (
        <StackedCell
          tabular
          primary={mesSigla && ano ? `${mesSigla}/${ano}` : undefined}
          secondary={row.original.dataFormatada}
        />
      )
    },
  }),
  sortableColumn<FaturaProfissionalDtoList>({
    id: 'quantidade',
    cellWidth: '136px',
    align: 'end',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'quantidade', label: t('cols.quantidade') }],
    Cell: ({ row }: CellProps<FaturaProfissionalDtoList>) => (
      <StackedCell tabular primary={row.original.quantidade} />
    ),
  }),
  sortableColumn<FaturaProfissionalDtoList>({
    id: 'valor',
    cellWidth: '152px',
    align: 'end',
    useQueryRequest,
    fields: [{ field: 'valor', label: t('cols.valor_receber') }],
    Cell: ({ row }: CellProps<FaturaProfissionalDtoList>) => (
      <StackedCell tabular primary={row.original.valorFormatado} />
    ),
  }),
  sortableColumn<FaturaProfissionalDtoList>({
    id: 'situacao',
    cellWidth: '136px',
    useQueryRequest,
    fields: [{ field: 'situacao', label: t('cols.situacao') }],
    Cell: ({ row }: CellProps<FaturaProfissionalDtoList>) => (
      <SituacaoFaturaBadge situacao={row.original.situacao} />
    ),
  }),
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '88px',
    align: 'end',
    Cell: ({ row }: CellProps<FaturaProfissionalDtoList>) => (
      <FaturaProfissionalActionsCell fatura={row.original} />
    ),
  },
]
